export enum MonitoringSeriesTypeEnum {
    folder = 'folder',
    topic = 'topic',
    allSavedCoverage = 'allSavedCoverage',
    tag = 'tags',
    tagGroup = 'tagGroups',
    subscription = 'subscription',
    sourceGroup = 'sourceGroups',
    socialTopic = 'socialTopic',
    theme = 'theme',
    aiAgent = 'aiAgent',
    currentSearch = 'currentSearch',
    coverageInSection = 'coverageInSection',
    allCuratedCoverageInBrief = 'allCuratedCoverageInBrief',
    coverageSurge = 'coverageSurge',
}
